export default __webpack_public_path__ + "static/media/view-perposal-icon.897515fc.svg";